document.addEventListener("DOMContentLoaded", () => {
  const app = document.getElementById("app");
  if (!app) return;

  // Tiny helper (you were using $ but never defined it)
  const $ = (id) => document.getElementById(id);

  // ---- Render UI into #app (this is the missing piece)
  app.innerHTML = `
    <div class="payout-wrap">
      <div class="payout-card">
        <h2>Inputs</h2>

        <div class="payout-row">
          <div>
            <label for="year">Year</label>
            <select id="year"></select>
          </div>
          <div>
            <label for="currency">Currency symbol</label>
            <input id="currency" value="$" />
          </div>
        </div>

        <div class="payout-row" style="margin-top:10px;">
          <div>
            <label for="totalPayout">Total Year-End Payout</label>
            <input id="totalPayout" type="number" step="0.01" value="20000" />
          </div>
          <div>
            <label for="staffRate">Staff Hourly Rate</label>
            <input id="staffRate" type="number" step="0.01" value="15" />
          </div>
        </div>

        <div style="margin-top:14px;">
          <h2>Timesheet</h2>
          <div class="payout-btnrow">
            <button id="reload" type="button">Reload timesheet.csv</button>
            <button id="calc" type="button">Recalculate</button>
            <button id="exportCsv" type="button" class="secondary">Export CSV</button>
          </div>

          <div style="margin-top:10px;">
            <label for="tsUpload">Upload timesheet.csv</label>
            <input id="tsUpload" type="file" accept=".csv,text/csv" />
            <div class="payout-note">Upload is the most reliable option on Shopify.</div>
          </div>

          <div id="status" class="payout-note payout-mono" style="margin-top:8px;">Waiting for timesheet…</div>
          <div id="warnings" class="payout-warn" style="margin-top:6px;"></div>
        </div>

        <div class="payout-note" style="margin-top:12px;">
          <strong>Rules</strong><br>
          Partner Hours come from <span class="payout-mono">Job</span>: Sherry, Bonnie-Jean.<br>
          Part-Time Hours Used come from <span class="payout-mono">Notes</span>: “for SA” → Sherry, “for BJM” → Bonnie-Jean.<br><br>
          PT adjustment: Avg PT = (PT Sherry + PT Bonnie-Jean)/2. Only the partner with the most PT gets PT Diff = MaxPT − AvgPT.
        </div>
      </div>

      <div class="payout-card">
        <h2>Results</h2>

        <div class="payout-kpis">
          <div class="payout-kpi">
            <div class="t">Total Partner Hours</div>
            <div class="v" id="kTotalHours">—</div>
          </div>
          <div class="payout-kpi">
            <div class="t">Avg Part-Time Hours Used</div>
            <div class="v" id="kAvgPt">—</div>
          </div>
          <div class="payout-kpi">
            <div class="t">Total Base Payout</div>
            <div class="v" id="kBaseTotal">—</div>
          </div>
          <div class="payout-kpi">
            <div class="t">Total Final Payout</div>
            <div class="v" id="kFinalTotal">—</div>
          </div>
        </div>

        <div id="summaryLine" class="payout-note" style="margin-top:10px;">—</div>

        <div style="margin-top:10px; overflow:auto;">
          <table class="payout-table">
            <thead>
              <tr>
                <th>Partner</th>
                <th class="r">Partner Hours</th>
                <th class="r">Part-Time Hours Used</th>
                <th class="r">Hour %</th>
                <th class="r">Base Payout</th>
                <th class="r">PT Hours Above Average</th>
                <th class="r">Adjustment</th>
                <th class="r">Final Payout</th>
              </tr>
            </thead>
            <tbody id="partnerRows"></tbody>
          </table>
        </div>
      </div>
    </div>
  `;

  // ---- Helpers
  function fmtMoney(n, symbol) {
    if (!isFinite(n)) return "—";
    const sign = n < 0 ? "-" : "";
    const abs = Math.abs(n);
    return sign + symbol + abs.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fmtNum(n, digits = 2) {
    if (!isFinite(n)) return "—";
    return n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }
  function percent(n) {
    if (!isFinite(n)) return "—";
    return (n * 100).toFixed(2) + "%";
  }
  function numFromInput(el) {
    const v = parseFloat(el.value);
    return isFinite(v) ? v : 0;
  }
  function setWarnings(msgs) {
    $("warnings").textContent = msgs.length ? msgs.join(" ") : "";
  }
  function setStatus(msg, ok = false) {
    const el = $("status");
    el.textContent = msg;
    el.style.color = ok ? "#0b6b0b" : "";
  }

  // ---- Year dropdown
  (function initYear() {
    const now = new Date();
    const y = now.getFullYear();
    const sel = $("year");
    for (let i = y - 5; i <= y + 1; i++) {
      const opt = document.createElement("option");
      opt.value = String(i);
      opt.textContent = String(i);
      if (i === y) opt.selected = true;
      sel.appendChild(opt);
    }
  })();

  // ---- Partner model
  const partners = [
    { name: "Sherry", jobMatch: /sherry/i, noteMatch: /\bfor\s*sa\b/i, hours: 0, ptUsed: 0 },
    { name: "Bonnie-Jean", jobMatch: /bonnie[- ]?jean/i, noteMatch: /\bfor\s*bjm\b/i, hours: 0, ptUsed: 0 },
  ];

  function renderPartners() {
    const tbody = $("partnerRows");
    tbody.innerHTML = "";
    partners.forEach((p, idx) => {
      const tr = document.createElement("tr");
      tr.innerHTML = `
        <td>${p.name}</td>
        <td class="r payout-mono" id="hours-${idx}">—</td>
        <td class="r payout-mono" id="pt-${idx}">—</td>
        <td class="r payout-mono" id="pct-${idx}">—</td>
        <td class="r payout-mono" id="base-${idx}">—</td>
        <td class="r payout-mono" id="diff-${idx}">—</td>
        <td class="r payout-mono" id="adj-${idx}">—</td>
        <td class="r payout-mono" id="final-${idx}">—</td>
      `;
      tbody.appendChild(tr);
    });
  }

  // ---- CSV parsing (same as yours)
  function simpleCsvParse(text) {
    const rows = [];
    let row = [];
    let cur = "";
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      const next = text[i + 1];

      if (ch === '"') {
        if (inQuotes && next === '"') { cur += '"'; i++; }
        else { inQuotes = !inQuotes; }
      } else if (ch === "," && !inQuotes) {
        row.push(cur); cur = "";
      } else if ((ch === "\n" || ch === "\r") && !inQuotes) {
        if (ch === "\r" && next === "\n") i++;
        row.push(cur);
        rows.push(row);
        row = []; cur = "";
      } else {
        cur += ch;
      }
    }
    if (cur.length || row.length) { row.push(cur); rows.push(row); }
    return rows.map(r => r.map(c => (c ?? "").trim()));
  }

  function rowsToObjects(rows) {
  // Normalize cell text
  const norm = (s) => String(s ?? "").trim().toLowerCase();

  // header synonyms (add more if needed)
  const isJob = (s) => ["job", "role", "employee", "name", "worker"].includes(norm(s));
  const isHours = (s) => ["hours", "hour", "duration", "time", "total"].includes(norm(s));
  const isNotes = (s) => ["notes", "note", "memo", "comment", "comments", "description"].includes(norm(s));

  // Find a plausible header row anywhere in the file
  // Requirement: has Job-ish and Hours-ish columns
  let headerIdx = -1;
  let header = [];

  for (let i = 0; i < rows.length; i++) {
    const r = rows[i] || [];
    const hasJob = r.some(isJob);
    const hasHours = r.some(isHours);
    if (hasJob && hasHours) {
      headerIdx = i;
      header = r.map(c => String(c ?? "").trim());
      break;
    }
  }

  if (headerIdx === -1) {
    throw new Error("Could not find a header row. Expected columns like Job + Hours (or Duration/Time).");
  }

  // Build objects from rows after the header
  const out = [];
  for (let i = headerIdx + 1; i < rows.length; i++) {
    const r = rows[i] || [];

    // Skip empty rows
    if (!r.some(cell => String(cell ?? "").trim() !== "")) continue;

    // Create row object
    const obj = {};
    for (let j = 0; j < header.length; j++) obj[header[j]] = r[j] ?? "";
    out.push(obj);
  }

  return out;
}


  function parseDurationToHours(value) {
    const s = String(value ?? "").trim();
    if (!s) return 0;

    const parts = s.split(":").map(x => x.trim());
    if (parts.length === 2) {
      const hh = parseInt(parts[0], 10);
      const mm = parseInt(parts[1], 10);
      if (!isFinite(hh) || !isFinite(mm)) return 0;
      return hh + (mm / 60);
    }
    if (parts.length === 3) {
      const hh = parseInt(parts[0], 10);
      const mm = parseInt(parts[1], 10);
      const ss = parseInt(parts[2], 10);
      if (!isFinite(hh) || !isFinite(mm) || !isFinite(ss)) return 0;
      return hh + (mm / 60) + (ss / 3600);
    }
    const f = parseFloat(s);
    return isFinite(f) ? f : 0;
  }

  function getField(obj, nameRegex) {
    const keys = Object.keys(obj);
    const k = keys.find(x => nameRegex.test(x));
    return k ? obj[k] : "";
  }

  function computeFromTimesheet(objects) {
    partners.forEach(p => { p.hours = 0; p.ptUsed = 0; });

    for (const row of objects) {
      const job = getField(row, /^job$/i);
      const notes = getField(row, /^notes$/i);
      const hoursVal = getField(row, /^hours$/i);

      const h = parseDurationToHours(hoursVal);

      partners.forEach(p => { if (p.jobMatch.test(job)) p.hours += h; });
      partners.forEach(p => { if (p.noteMatch.test(notes)) p.ptUsed += h; });
    }
  }

  function calculate() {
    const warnings = [];
    const symbol = $("currency").value || "$";
    const totalPayout = numFromInput($("totalPayout"));
    const staffRate = numFromInput($("staffRate"));

    const totalHours = partners.reduce((sum, p) => sum + p.hours, 0);

    // Avg PT rule + max partner diff
    const totalPtUsed = partners.reduce((sum, p) => sum + p.ptUsed, 0);
    const avgPtUsed = partners.length ? (totalPtUsed / partners.length) : 0;

    let maxPtIdx = -1;
    let maxPtVal = -Infinity;
    partners.forEach((p, i) => {
      if (p.ptUsed > maxPtVal) { maxPtVal = p.ptUsed; maxPtIdx = i; }
    });

    let baseTotal = 0;
    let finalTotal = 0;

    partners.forEach((p, idx) => {
      const hourPct = totalHours > 0 ? (p.hours / totalHours) : 0;
      const base = totalPayout * hourPct;

      const ptDiff = (idx === maxPtIdx) ? Math.max(0, (p.ptUsed - avgPtUsed)) : 0;
      const adj = ptDiff * staffRate;
      const final = base - adj;

      baseTotal += base;
      finalTotal += final;

      $(`hours-${idx}`).textContent = fmtNum(p.hours, 2);
      $(`pt-${idx}`).textContent = fmtNum(p.ptUsed, 2);
      $(`pct-${idx}`).textContent = percent(hourPct);
      $(`base-${idx}`).textContent = fmtMoney(base, symbol);
      $(`diff-${idx}`).textContent = fmtNum(ptDiff, 2);
      $(`adj-${idx}`).textContent = fmtMoney(adj, symbol);
      $(`final-${idx}`).textContent = fmtMoney(final, symbol);
    });

    $("kTotalHours").textContent = fmtNum(totalHours, 2);
    $("kAvgPt").textContent = fmtNum(avgPtUsed, 2);
    $("kBaseTotal").textContent = fmtMoney(baseTotal, symbol);
    $("kFinalTotal").textContent = fmtMoney(finalTotal, symbol);

    const year = $("year").value;
    $("summaryLine").textContent =
      `Year ${year} • Total payout ${fmtMoney(totalPayout, symbol)} • Staff rate ${fmtMoney(staffRate, symbol)} • Upload timesheet.csv to update totals`;

    if (totalHours === 0) warnings.push("Total partner hours is 0 — check that the timesheet has a 'Job' column with 'Sherry' and 'Bonnie-Jean' rows.");
    setWarnings(warnings);
  }

  async function loadTimesheetCsvFromFolder() {
    // This generally won't work on Shopify unless timesheet.csv is publicly reachable at /timesheet.csv
    try {
      setStatus("Loading /timesheet.csv …");
      const res = await fetch("/timesheet.csv", { cache: "no-store" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const text = await res.text();

      const rows = simpleCsvParse(text);
      const objects = rowsToObjects(rows);
      computeFromTimesheet(objects);
      calculate();

      setStatus("Loaded /timesheet.csv ✓", true);
    } catch (err) {
      setStatus("Auto-load failed. Please upload timesheet.csv.", false);
    }
  }

  function csvSafe(s) {
    const str = String(s ?? "");
    if (/[",\n\r]/.test(str)) return `"${str.replaceAll('"', '""')}"`;
    return str;
  }

  function exportCsv() {
    const symbol = $("currency").value || "$";
    const year = $("year").value;
    const totalPayout = numFromInput($("totalPayout"));
    const staffRate = numFromInput($("staffRate"));

    const totalHours = partners.reduce((sum, p) => sum + p.hours, 0);
    const totalPtUsed = partners.reduce((sum, p) => sum + p.ptUsed, 0);
    const avgPtUsed = partners.length ? (totalPtUsed / partners.length) : 0;

    let maxPtIdx = -1;
    let maxPtVal = -Infinity;
    partners.forEach((p, i) => {
      if (p.ptUsed > maxPtVal) { maxPtVal = p.ptUsed; maxPtIdx = i; }
    });

    const lines = [];
    lines.push(["Total Year-End Payout", `${symbol}${totalPayout.toFixed(2)}`].join(","));
    lines.push(["Staff Hourly Rate", `${symbol}${staffRate.toFixed(2)}`].join(","));
    lines.push(["Avg Part-Time Hours Used", avgPtUsed.toFixed(2)].join(","));
    lines.push([""].join(","));
    lines.push([
      "Partner","Partner Hours","Part-Time Hours Used","Hour %","Base Payout","PT Hours Above Average","Adjustment","Final Payout"
    ].join(","));

    partners.forEach((p, i) => {
      const hourPct = totalHours > 0 ? (p.hours / totalHours) : 0;
      const base = totalPayout * hourPct;
      const ptDiff = (i === maxPtIdx) ? Math.max(0, (p.ptUsed - avgPtUsed)) : 0;
      const adj = ptDiff * staffRate;
      const final = base - adj;

      lines.push([
        csvSafe(p.name),
        p.hours.toFixed(2),
        p.ptUsed.toFixed(2),
        hourPct.toFixed(6),
        `${symbol}${base.toFixed(2)}`,
        ptDiff.toFixed(2),
        `${symbol}${adj.toFixed(2)}`,
        `${symbol}${final.toFixed(2)}`
      ].join(","));
    });

    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `painted_door_payout_${year}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  // ---- Wiring (safe now because the elements exist)
  $("reload").addEventListener("click", loadTimesheetCsvFromFolder);
  $("calc").addEventListener("click", calculate);
  $("exportCsv").addEventListener("click", exportCsv);
  ["currency","totalPayout","staffRate","year"].forEach(id => $(id).addEventListener("input", calculate));

  $("tsUpload").addEventListener("change", async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const text = await file.text();
    try {
      const rows = simpleCsvParse(text);
      const objects = rowsToObjects(rows);
      computeFromTimesheet(objects);
      calculate();
      setStatus(`Loaded uploaded file: ${file.name} ✓`, true);
      setWarnings([]);
    } catch (err) {
      setStatus("Upload failed to parse. Make sure the CSV includes 'Job', 'Hours', and 'Notes' headers.", false);
      setWarnings([String(err.message || err)]);
    }
    e.target.value = "";
  });

  // ---- Init
  renderPartners();
  calculate();
});
